import { useDebounce } from '@shared/hooks'

import { useFiltersContext } from '@/context'
import { HomeQueries } from '@/graphql/queries/home.queries'
import { HomesResponse } from '@/types/Homes'
import { getHomesFilterParams } from '@/util/FiltersUtil'

import { useGraphql } from '../useGraphql'

const useHomes = () => {
  const [{ marketSegmentFilter, homesFilters, searchString }] = useFiltersContext()
  const debouncedSearch = useDebounce(searchString, 1000)

  const filterParams = {
    marketSegmentIds: marketSegmentFilter.marketSegmentIds,
    ...getHomesFilterParams(homesFilters),
  }
  const homesQuery = useGraphql<{ homes: HomesResponse[] }>(
    HomeQueries.QUERY_KEYS.getHomesList,
    HomeQueries.getHomesList(),
    {
      filter: filterParams,
      searchString: debouncedSearch,
    },
  )
  return homesQuery
}

export default useHomes
